import { HttpError, isError } from "../../helpers/Error"
import HttpClient from "../../helpers/HttpClient"
import { PaymentRefundPayload } from "../../invoice/Constants"
import RefundPayments, { RefundPaymentsDto } from "./RefundPayments"

class RefundService {
    static httpClient: HttpClient<RefundPayments, RefundPaymentsDto> = new HttpClient<RefundPayments, RefundPaymentsDto>(RefundPayments)

    static async processVoid(invoiceId: string, payload: PaymentRefundPayload): Promise<RefundPayments | HttpError> {
        const res = await this.httpClient.post(`/invoices/${invoiceId}/void`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as RefundPayments
    }

    static async processRefund(returnId: string, payload: PaymentRefundPayload): Promise<RefundPayments | HttpError> {
        const res = await this.httpClient.post(`/returns/${returnId}/refunds`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as RefundPayments
    }

    static async processCreditMemoRefund(creditMemoId: string, payload: PaymentRefundPayload): Promise<RefundPayments | HttpError> {
        const res = await this.httpClient.post(`/credit-memos/${creditMemoId}/refunds`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as RefundPayments
    }
}

export default RefundService


// WEBPACK FOOTER //
// ./src/state/payment/refund/RefundService.ts